/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";
import type { UserRoleDTO } from "./UserRoleDTO";
import { UserRoleDTOFromJSON, UserRoleDTOFromJSONTyped, UserRoleDTOToJSON } from "./UserRoleDTO";

/**
 *
 * @export
 * @interface InUserDTO
 */
export interface InUserDTO {
  /**
   *
   * @type {UserRoleDTO}
   * @memberof InUserDTO
   */
  role: UserRoleDTO;
  /**
   *
   * @type {string}
   * @memberof InUserDTO
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof InUserDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof InUserDTO
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof InUserDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof InUserDTO
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof InUserDTO
   */
  id?: number;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof InUserDTO
   */
  merchants: Array<GenericIdDTO>;
}

/**
 * Check if a given object implements the InUserDTO interface.
 */
export function instanceOfInUserDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "role" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "merchants" in value;

  return isInstance;
}

export function InUserDTOFromJSON(json: any): InUserDTO {
  return InUserDTOFromJSONTyped(json, false);
}

export function InUserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InUserDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    role: UserRoleDTOFromJSON(json["role"]),
    company: !exists(json, "company") ? undefined : json["company"],
    firstName: !exists(json, "firstName") ? undefined : json["firstName"],
    lastName: !exists(json, "lastName") ? undefined : json["lastName"],
    email: json["email"],
    phone: !exists(json, "phone") ? undefined : json["phone"],
    id: !exists(json, "id") ? undefined : json["id"],
    merchants: (json["merchants"] as Array<any>).map(GenericIdDTOFromJSON)
  };
}

export function InUserDTOToJSON(value?: InUserDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    role: UserRoleDTOToJSON(value.role),
    company: value.company,
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    phone: value.phone,
    id: value.id,
    merchants: (value.merchants as Array<any>).map(GenericIdDTOToJSON)
  };
}
